import React from 'react';
import styles from './Text.module.css';

type TextVariant = 'body' | 'caption' | 'label' | 'error' | 'heading';
type TextAlign = 'left' | 'center' | 'right';
type TextColor = 'muted' | 'primary' | 'link';
type TextTag = 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'label';

interface TextProps {
  variant?: TextVariant;
  align?: TextAlign;
  bold?: boolean;
  color?: TextColor;
  className?: string;
  as?: TextTag;
  onClick?: () => void;
  children: React.ReactNode;
}

const Text: React.FC<TextProps> = ({
  variant = 'body',
  align,
  bold = false,
  color,
  className = '',
  as: Tag = 'span',
  onClick,
  children,
}) => {
  const classes = [
    styles.text,
    styles[variant],
    align ? styles[align] : '',
    bold ? styles.bold : '',
    color ? styles[color] : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <Tag className={classes} onClick={onClick}>{children}</Tag>;
};

export default Text;
